import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Stack } from '@mui/material';

import { Icon, IconButton } from 'ui';

const SocialMedia = ({ orientation = 'horizontal' }) => {
  const data = useStaticQuery(graphql`
    query {
      allSite {
        edges {
          node {
            siteMetadata {
              socialMediaUrls {
                email
                github
                instagram
                linkedin
              }
            }
          }
        }
      }
    }
  `);

  const { socialMediaUrls } = data.allSite.edges[0].node.siteMetadata;

  return (
    <Stack
      direction={orientation === 'horizontal' ? 'row' : 'column'}
      justifyContent='center'
      mb={2}
      gap={1}>
      <IconButton href={socialMediaUrls.instagram}>
        <Icon name='Instagram' />
      </IconButton>

      <IconButton href={socialMediaUrls.linkedin}>
        <Icon name='Linkedin' />
      </IconButton>

      <IconButton href={socialMediaUrls.github}>
        <Icon name='GitHub' />
      </IconButton>

      <IconButton href={socialMediaUrls.email}>
        <Icon name='Mail' />
      </IconButton>
    </Stack>
  );
};

export default SocialMedia;
